/** Общие подписи и разбор результата для глобального поиска (TZ + личный кабинет). */

export const GLOBAL_SEARCH_PIPELINE_LABELS = {
  yandex_search: 'Глобальный поиск',
  similarity: 'Сравнение по сходству',
  completed: 'Готово',
  error: 'Ошибка',
};

export function formatGlobalSearchDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('ru-RU');
  } catch {
    return String(iso);
  }
}

export function pickYandexImageSearchRequest(task) {
  const list = task?.requests;
  if (!Array.isArray(list)) return null;
  return list.find((r) => r.request_type === 'yandexImageSearch') || null;
}

export function extractGlobalSearchResultPayload(resultField) {
  if (resultField == null) return null;
  if (typeof resultField !== 'object') return null;
  const inner = resultField.result ?? resultField;
  if (inner && typeof inner === 'object' && inner.result && typeof inner.result === 'object') {
    return inner.result;
  }
  return inner;
}

export function hasGlobalSearchReportContent(payload) {
  if (!payload || typeof payload !== 'object') return false;
  return !!(
    (Array.isArray(payload.yandexSearch) && payload.yandexSearch.length > 0) ||
    (Array.isArray(payload.yandexUrls) && payload.yandexUrls.length > 0) ||
    payload.similarities != null
  );
}
